"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _material = require("@mui/material");

var _styles = require("@mui/material/styles");

var _Autocomplete = require("@mui/material/Autocomplete");

var _Chip = _interopRequireDefault(require("@mui/material/Chip"));

var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));

var _Checkbox = _interopRequireDefault(require("@mui/material/Checkbox"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _TextField = _interopRequireDefault(require("../TextField/TextField"));

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Root = (0, _styles.styled)("div")(function () {
  return "\n  color: rgba(0,0,0,.85);\n  font-size: 0.9rem;\n  position: relative;\n  min-width: 18rem;\n";
});
var InputWrapper = (0, _styles.styled)("div")(function () {
  return "\n  border: 1px solid #d9d9d9;\n  background-color: #fff;\n  padding: 1px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  &:hover {\n    border-color: #40a9ff;\n  }\n  &.focused {\n    border-color: #40a9ff;\n    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);\n  }\n  & .MuiTextField-root {\n    background-color: #fff;\n    color: rgba(0,0,0,.85);\n    height: 1.85rem;\n    box-sizing: border-box;\n    width: 0;\n    min-width: 1.85rem;\n    flex-grow: 1;\n    border: 0;\n    margin: 0;\n    outline: 0;\n    & .MuiInput-root{\n      border: unset;\n    }\n  }\n";
});
var Listbox = (0, _styles.styled)("ul")(function () {
  return "\n  width: 100%;\n  margin: 2px 0 0;\n  padding: 0;\n  position: absolute;\n  list-style: none;\n  background-color: #fff;\n  overflow: auto;\n  max-height: 15rem;\n  border-radius: 4px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 1;\n  & li {\n    padding: 0.31rem 0.75rem;\n    display: grid;\n    grid-template-columns: 5% 90% 5%;\n    align-items: center;\n    & .content{\n      margin-left: 0.63rem;\n    }\n    &.no-record {\n      padding: 0.63rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n  & li[aria-selected='true'] {\n    background-color: #fafafa;\n    font-weight: 600;\n    & svg {\n      color: #1890ff;\n    }\n  }\n  & li.".concat(_Autocomplete.autocompleteClasses.focused, " {\n    background-color: #e6f7ff;\n    cursor: pointer;\n  }\n");
});
var IconContainer = (0, _styles.styled)("span")(function (_ref) {
  var theme = _ref.theme;
  return "\n  margin-left: 5px;\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  padding: 5px;\n  color: rgba(0, 0, 0, 0.54);\n  & .fa-pencil-alt {\n    color: ".concat(theme.palette.primary.main, " !important;\n  }\n");
});
var StyledButton = (0, _styles.styled)(_material.Button)(function (_ref2) {
  var theme = _ref2.theme;
  return "\n  color: ".concat(theme.palette.primary.main, ";\n  font-weight: 700;\n  font-size: 0.80rem;\n");
});
var StyledChip = (0, _styles.styled)(_Chip.default)(function (_ref3) {
  var theme = _ref3.theme;
  return "\n  margin: 1px;\n  color: ".concat(theme.palette.brand.grey.charcoal, ";\n");
});

var AutoCompleteAdornment = function AutoCompleteAdornment(_ref4) {
  var popupOpen = _ref4.popupOpen,
      onClick = _ref4.onClick,
      shouldShowCreate = _ref4.shouldShowCreate,
      onCreate = _ref4.onCreate,
      createLabel = _ref4.createLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InputAdornment.default, {
    position: "end",
    children: [shouldShowCreate && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledButton, {
      variant: "text",
      onClick: onCreate,
      children: createLabel
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IconContainer, {
      onClick: onClick,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        iconStyle: "fas",
        iconName: popupOpen ? "caret-up" : "caret-down"
      })
    })]
  });
};

var AutocompleteAdvanced = function AutocompleteAdvanced(_ref5) {
  var id = _ref5.id,
      onCreateNew = _ref5.onCreateNew,
      onEdit = _ref5.onEdit,
      options = _ref5.options,
      values = _ref5.values,
      _onChange = _ref5.onChange,
      labels = _ref5.labels,
      _ref5$limitTags = _ref5.limitTags,
      limitTags = _ref5$limitTags === void 0 ? 0 : _ref5$limitTags;

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  var selectedOptions = (0, _react.useMemo)(function () {
    return options.filter(function (option) {
      return values.includes(option.value);
    });
  }, [values, options]);

  var _useAutocomplete = (0, _material.useAutocomplete)({
    id: id,
    multiple: true,
    options: options,
    getOptionLabel: function getOptionLabel(option) {
      return option.label;
    },
    disableCloseOnSelect: true,
    onInputChange: function onInputChange(_, val) {
      return setInput(val);
    },
    onChange: function onChange(_, val) {
      return _onChange(val);
    },
    value: selectedOptions
  }),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      groupedOptions = _useAutocomplete.groupedOptions,
      value = _useAutocomplete.value,
      focused = _useAutocomplete.focused,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      popupOpen = _useAutocomplete.popupOpen,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps;

  var limitedRecords = (0, _react.useMemo)(function () {
    if (!limitTags) {
      return {
        result: value,
        extra: 0
      };
    }

    return {
      extra: value.length - limitTags,
      result: (0, _toConsumableArray2.default)(value).slice(0, limitTags)
    };
  }, [value, limitTags]);
  var shouldShowCreate = (0, _react.useMemo)(function () {
    if ((groupedOptions || []).length && !!input) {
      return groupedOptions.filter(function (_ref6) {
        var label = _ref6.label;
        return label.toLowerCase() === input.toLowerCase();
      }).length === 0;
    }

    return !!input && focused && !(groupedOptions || []).length;
  }, [input, focused, groupedOptions]);

  var onCreateClick = function onCreateClick() {
    onCreateNew(input);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(InputWrapper, {
        ref: setAnchorEl,
        className: focused ? "focused" : "",
        children: [!focused && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [limitedRecords.result.map(function (option, index) {
            return /*#__PURE__*/(0, _react.createElement)(StyledChip, _objectSpread(_objectSpread({
              variant: "outlined",
              size: "small",
              label: option.label
            }, getTagProps({
              index: index
            })), {}, {
              key: "chips-".concat(option.value)
            }));
          }), limitTags > 0 && value.length > limitTags ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledChip, {
            variant: "outlined",
            size: "small",
            label: "+".concat(limitedRecords.extra)
          }) : null]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, _objectSpread({
          inputProps: getInputProps(),
          InputProps: {
            endAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(AutoCompleteAdornment, _objectSpread({
              createLabel: labels.create,
              onCreate: onCreateClick,
              shouldShowCreate: shouldShowCreate,
              popupOpen: popupOpen
            }, getPopupIndicatorProps()))
          }
        }, labels.placeholder && !limitedRecords.result.length ? {
          placeholder: labels.placeholder
        } : {}))]
      })
    })), groupedOptions.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(Listbox, _objectSpread(_objectSpread({}, getListboxProps()), {}, {
      children: groupedOptions.map(function (option, index) {
        if ("label" in option) {
          var optionProps = getOptionProps({
            option: option,
            index: index
          });
          return /*#__PURE__*/(0, _react.createElement)("li", _objectSpread(_objectSpread({}, optionProps), {}, {
            key: "lists-".concat(option.value)
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.default, {
            checked: !!optionProps["aria-selected"] || false
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "content",
            children: option.label
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(IconContainer, {
            onClick: function onClick(e) {
              e.preventDefault();
              e.stopPropagation();
              onEdit(option);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
              iconStyle: "fas",
              iconName: "pencil-alt"
            })
          }));
        }

        return null;
      })
    })), popupOpen && !groupedOptions.length && /*#__PURE__*/(0, _jsxRuntime.jsx)(Listbox, _objectSpread(_objectSpread({}, getListboxProps()), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("li", {
        className: "no-record",
        children: [" ", labels.noRecords, " "]
      })
    }))]
  });
};

var _default = AutocompleteAdvanced;
exports.default = _default;